<template>
  <div class="analytics-page" >
    <div class="chart-container">
      <div id="chart" v-loading="loading">
        <apexchart :key="chartKey" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div class=" p-2">
        <div class="legend-item">
          <div class="color-box yellow"></div>
          <span>Total Shipping Cost</span>
        </div>
        <hr class="horixon">
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';


export default {
  props: {
    shippingSpend: {
      type: Array,
      required: true,
    },
  },
  watch: {
    shippingSpend: {
      immediate: true,
      handler(newData) {
        this.loading = !this.loading
        this.updateChart(newData);
        setTimeout(() =>{
          this.loading = !this.loading
        }, )
      },
    },
  },
  methods: {
    updateChart(data) {     
      if (data.length === 0) {
      this.series[0].data 
      } else {
      const counts = data.map(sSpend => parseInt(sSpend.totalamount)); 
      this.series[0].data = counts       
      }        
      this.chartKey ++; 
      this.fillXAxisWithDates(data);
    },
    fillXAxisWithDates(data) {
      const dates = [''];
      if (data.length === 0) {
        for (let i =data.length+9; i >= 1; i--) {
          dates.push(moment().subtract(i, 'days').format('MMMM-DD'));
        }
        dates.push(moment().format('MMMM-DD')); // Add the current date
        this.chartOptions.xaxis.categories = dates;
      } else {
        const days = data.map(sSpend => parseInt(sSpend.day));
        const months = data.map(sSpend => (sSpend.month));
        const monthNames = this.mapFiguresToMonths(months);
        for (let i = 0; i < data.length; i++) {
          dates[i] = monthNames[i] + '-' + days[i]
        }
      }
      this.chartOptions.xaxis.categories = dates;
    },
    mapFiguresToMonths(figures) {
      const monthMap = {1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun',
       7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'
      };
      return figures.map(figure => monthMap[figure]);
    },
  },

  data: function () {
    return {
      chartKey: 0,
      loading: false, // State to control the loading indicator
      series: [{
        name: "Shipping Spend",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }],
      chartOptions: {
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: false
            }
          },
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          //   curve: 'stepline',
          //   curve: 'smooth',
          width: 2
        },
        title: {
          text: 'Shipping Spend',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
          column: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
            // columnWidth: '15%'
          }
        },
        xaxis: {
          categories: [],
        },
      
        yaxis: {
          title: {
            text: "Amount",
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
            }
          },
          labels: {
            formatter: function (val) {
              return "₦" + val.toLocaleString(); // format with ₦ and commas
            }
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "" + val + ""
              // return "# " + val + " thousands"
            }
          }
        },
        colors: ['#F7B643']
      },
    }
  },

}
</script>

<style scoped>
.analytics-page {
  width: 97%;
  padding: 20px;
  border: 2px solid transparent;
  margin-bottom: 5%;
  margin-top: 2%;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 2px #00000014;
}

.chart-container {
  height: 400px;
}

.legend-item {
  display: flex;
  align-items: center;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
}

span {
  margin-left: 7px;
}

.horixon {
  border: 0.5px solid #9BA0A7;
}

.yellow {
  background-color: #FCC210;
}
</style>